import Main from './_main';
import Top from './_top';
import Map from './_map';
import Movie from './_movie';
import Story from './_story';

new Main();
new Top();
new Map();
new Movie();
new Story();
